import { Node } from 'slate'
import { propEq } from 'ramda'

export const serializeText = value => {
  return value.map(n => Node.string(n)).join('\n')
}

export const deserializeText = (value, interpolations = []) => {
  const children = interpolations
    .reduce((acc, interpolation) => {
      return String(acc).replaceAll(interpolation.id, `__BREAK__${interpolation.id}__BREAK__`)
    }, String(value) || '')
    .split('__BREAK__')
    .map(val => {
      const interpolation = interpolations.find(propEq('id', val))
      if (!interpolation) return { text: val }
      return { type: 'interpolation', name: interpolation.name, children: [{ text: val }] }
    })

  return [
    {
      type: 'paragraph',
      children
    }
  ]
}
